const ENV = process.env.REACT_APP_ENVIRONMENT || 'development';

export const apiBase =
  ENV === 'production'
    ? 'https://api.demigod.ai'
    : ENV === 'staging'
    ? 'https://api.demigod.work'
    : 'http://localhost:7074';
